export const DOWNLOAD_CHAT_CONVERSATION_SUCCESS = 'DOWNLOAD_CHAT_CONVERSATION_SUCCESS';

export const downloadChatConversationSuccess = () => ({
    type: DOWNLOAD_CHAT_CONVERSATION_SUCCESS,
});
